import React from 'react';
import { Navigate } from 'react-router-dom';

const EmployerWorkHistory = () => {
  // Legacy page: Redirect to the robust Timesheets page
  return <Navigate to="/employer/timesheets" replace />;
};

export default EmployerWorkHistory;